import { NotificationService } from '../../../../../common/services';
import { CustomHttpErrorResponse, Error } from '../../../../../common/constants';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ShipmentSpecialFreightTrackingMapLoad,
  ShipmentSpecialFreightTrackingMapInitialState,
} from './shipment-special-freight-tracking-map.actions';
import { ShipmentSpecialFreightTrackingMapService } from './shipment-special-freight-tracking-map.service';
import { Injectable } from '@angular/core';
import { ShipmentSpecialFreightMapData } from '../../models/shipment-special-freight-tracking-map.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ShipmentLoadToGpsPointModel } from '../../../../models';

export interface ShipmentSpecialFreightTrackingMapStateModel {
  mapData: ShipmentSpecialFreightMapData;
  loaded: boolean;
}

const initialState: ShipmentSpecialFreightTrackingMapStateModel = {
  mapData: null,
  loaded: false,
};

@State<ShipmentSpecialFreightTrackingMapStateModel>({
  name: 'shipmentSpecialFreightTrackingMapData',
  defaults: initialState,
})
@Injectable()
export class ShipmentSpecialFreightTrackingMapState {
  @Selector()
  static getState(state: ShipmentSpecialFreightTrackingMapStateModel): ShipmentSpecialFreightTrackingMapStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentSpecialFreightTrackingMapStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getMapData(state: ShipmentSpecialFreightTrackingMapStateModel): ShipmentSpecialFreightMapData {
    return state.mapData;
  }

  constructor(
    private shipmentSpecialFreightTrackingMapService: ShipmentSpecialFreightTrackingMapService,
    private notificationService: NotificationService,
  ) {}

  @Action(ShipmentSpecialFreightTrackingMapLoad)
  getWaybillTrackingMapData(
    ctx: StateContext<ShipmentSpecialFreightTrackingMapStateModel>,
    { payload }: ShipmentSpecialFreightTrackingMapLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentSpecialFreightTrackingMapService.getShipmentLoadTrackingMapData(payload).pipe(
      map((mapData: ShipmentSpecialFreightMapData) => {
        const gpsPoints = mapData.gpsPoints.map((point: ShipmentLoadToGpsPointModel, index: number) => {
          point.sortIndex = `${index}`;
          return point;
        });
        ctx.patchState({ mapData: { gpsPoints, transportMode: mapData.transportMode }, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentSpecialFreightTrackingMapInitialState)
  setInitialState(ctx: StateContext<ShipmentSpecialFreightTrackingMapStateModel>): void {
    ctx.setState(initialState);
  }
}
